module.exports = __webpack_public_path__ + "assets/img/1411.fbc40904.png";